export const ROOT_IMG_URL = '/react-templates/templates/2025_VOG/build/images/';

export const ButtonBasicStyle = {
  border: '1px solid var(--secondary-color)',
  borderRadius: 'var(--b-radius)',
  fontWeight: 'bold',
  color: 'black',
  fontStyle: 'italic',
  padding: 'var(--gutter-s) var(--gutter-m)',
};

export const DEBUG_GOODAYS_ID = 'CV258000';
export const HAIRNET_ID = 'hrntrdv';